class CountdownElement extends HTMLElement {
  connectedCallback() {
    const duration = 10 * 60; // 10 Minuten
    let remaining = duration;

    const minutesEl = this.querySelector('.js-timerMinutes');
    const secondsEl = this.querySelector('.js-timerSeconds');

    const update = () => {
      const minutes = Math.floor(remaining / 60);
      const seconds = remaining % 60;

      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');

      if (remaining > 0) {
        remaining--;
        setTimeout(update, 1000);
      } else {
        this.innerHTML = 'Zeit abgelaufen!';
      }
    };

    update();
  }
}

customElements.define('countdown-element', CountdownElement);
